import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import CategoryGrid from "./components/CategoryGrid";
import SeoContent from "./components/SeoContent";
import ComparisonTable from "./components/ComparisonTable";
import ArticleGrid from "./components/ArticleGrid";
import SafetySection from "./components/SafetySection";
import Testimonials from "./components/Testimonials";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Hoobuy Sheet",
  "url": "https://hoobuy.autos/",
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg",
  "description": "Guia completo do Hoobuy Spreadsheet com lista atualizada de produtos, comparação de preços e dicas de compra na China.",
  "sameAs": ["https://kaspreadsheet.com"],
  "foundingDate": "2025",
  "inLanguage": "pt-BR"
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <FeatureGrid />
      <CategoryGrid />
      <SeoContent />
      <ComparisonTable />
      <ArticleGrid />
      <Testimonials />
      <SafetySection />
      <CtaSection />
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
    </main>
  );
}